<template>
  <div>
    <el-dialog :visible.sync="showDialog"
               custom-class="window"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :show-close="false"
               width="30%"
               top="10vh"
               :title="$t('member.AddMembers')">
      <span slot="title"
            class="dialog-header">
        {{$t('member.AddMembers')}}
        <el-button size="small"
                   type="primary"
                   style="float:right;margin-bottom:15px;"
                   @click="openUserDialog()">{{$t('corp.NewUser')}}</el-button>
      </span>
      <div style="height:500px">
        <el-row style="margin-bottom:10px">
          <el-col :span="24">
            <el-input :placeholder="$t('members.SearchMemberNameOrEmail')"
                      size="small"
                      @change="search()"
                      clearable
                      @clear="getCorpUser()"
                      v-model="condition.NameOrEmail"></el-input>
          </el-col>
        </el-row>
        <myScroll style="width:100%;height:85%">
          <el-table :data="list"
                    class="table"
                    v-loading="loading"
                    ref="table"
                    :stripe="true"
                    @selection-change="handleSelectionChange"
                    :show-header="false"
                    :row-key="getRowKeys">
            <el-table-column type="selection"
                             :reserve-selection="true"
                             width="42">
            </el-table-column>
            <el-table-column width="45">
              <template slot-scope="scope">
                <div class="user-logo">
                  <img :src="scope.row.AvatarUrl"
                       alt="">
                </div>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <div>{{scope.row.FullName}} -- {{scope.row.RoleName}}</div>
                <div>{{scope.row.LoginAccount}}</div>
              </template>
            </el-table-column>
          </el-table>
        </myScroll>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeDialog"
                   size="small">{{$t('member.Cancel')}}</el-button>
        <el-button type="primary"
                   size="small"
                   @click="save"
                   :disabled="saveList.length < 1">{{$t('member.Add')}}</el-button>
      </div>
    </el-dialog>
    <UserDialog :showDialog="UserDialog.showDialog"
                :id="UserDialog.id"
                :showResidualAlert="UserDialog.showResidualAlert"
                @closeDialog="closeUserDialog"></UserDialog>
  </div>
</template>

<script>
import { getCorpUser, addProjectMember, getCorpLicense } from '@/api/config'
import { mapState } from 'vuex'
import UserDialog from '@components/corp/userDialog.vue'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    outsideList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      saveList: [],
      list: [],
      total: 0,
      loading: false,
      totalList: [],
      condition: {
        NameOrEmail: null,
        PageIndex: 1,
        PageSize: 1000,
        OrderBy: 'LastUpdatedOn desc'
      },
      UserDialog: {
        showDialog: false,
        id: null
      },
      LicenseObj: {}
    }
  },
  computed: {
    ...mapState(['jobsiteID'])
  },
  created () {
  },
  mounted () {

  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.PageIndex = 1
        this.list = []
        this.condition.FullName = null
        this.getCorpUser()
      }
    }
  },
  methods: {
    getRowKeys (row) {
      return row.UserId
    },
    search () {
      this.getCorpUser()
    },
    handleSelectionChange (val) {
      this.saveList = []
      if (val.length > 0) {
        val.forEach(ele => {
          let obj = {
            JobsiteId: this.jobsiteID,
            UserId: ele.UserId,
            IsDeleted: false
          }
          this.saveList.push(obj)
        })
      }
    },
    closeDialog () {
      this.list = []
      this.$refs.table.clearSelection()
      this.$emit('closeDialog')
    },
    getCorpUser () {
      this.loading = true
      getCorpUser(this.condition).then(res => {
        if (this.outsideList.length > 0) {
          for (let j in this.outsideList) {
            for (let i in res.Data) {
              let data = res.Data[i]
              if (this.outsideList[j].UserId === data.UserId) {
                res.Data.splice(i, 1)
              }
            }
          }
        }
        res.Data.forEach(ele => {
          ele.AvatarUrl = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId + '?isAvatar=true'
        })
        this.loading = false
        this.list = res.Data
      })
    },
    save () {
      addProjectMember(this.saveList).then(res => {
        this.closeDialog()
      })
    },
    getCorpLicense () {
      getCorpLicense(0).then(res => {
        this.LicenseObj = res
        this.licenseText = this.$config.licenseText(res)
      })
    },
    openUserDialog (id) {
      if (id) {
        this.UserDialog.id = id
        this.UserDialog.showDialog = true
      } else {
        if (this.LicenseObj.LicenseProductId && this.LicenseObj.LicenseProductId.length > 0 && this.LicenseObj.ResidualLicenseQty === 0) {
          this.$alert(this.$t('corp.ResidualLicenseForNewUserTooltip'))
        }
        this.UserDialog.id = null
        this.UserDialog.showDialog = true
      }
    },
    closeUserDialog () {
      this.UserDialog.id = null
      this.getCorpUser()
      this.UserDialog.showDialog = false
      this.getCorpLicense()
    }
  },
  components: {
    UserDialog
  }
}
</script>

<style scoped lang="scss">
.el-pagination {
  margin-top: 10px;
  text-align: right;
}
.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 10;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
